module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAKlBMVEX/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE3/zE0d8jQTAAAADnRSTlMw7/9wAK+fQM8QgL9gIDTMwooAAAD2SURBVHgBjc2xSUVRAIPh4wbiBvcImcARDqiFIM4guMDFAZzBwgGE1zvCa13AcWw0pAn/Tf3xZ1xsN4s2nqYYzTmfjyAxgpSRGEHKSIwgZSRGkDISI0gZCZBTjATIKUYC5BQjAXKKkQA5xUiAnGIkQE4xEiCnGImRU4DEyClAYuQUIFX08tZTRvtHTxm93/eU0VqZqqimEvVUoppKVFOJaipRTSWqqUQ1laimEtVUoppKVFNGe00F+qypQJf/6NbGKaPt9Hf3GkhGZU4hEiCnGAmQU4wEyClG6ihTR5DW+JqcGmdG1+OO0TYerliN9TO5tNY3ocdfkdERr8v5kXkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f4d0.png
// module id = 1031
// module chunks = 0